import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { EventService } from '../services/event.service';
import { IEvent } from '../models/IEvent';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit, OnDestroy {
  events: IEvent[];
  filteredEvents: IEvent[];
  subscription: Subscription;
  themes$: Observable<any>;
  PLACEHOLDER_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/froodini-d5dad.appspot.com/o/placeholder.jpg?alt=media&token=16ef0fe2-9a67-4fef-91ef-1910417ec165';

  constructor(private eventService: EventService, private themeService: ThemeService) { }

  ngOnInit(): void {
    this.themes$ = this.themeService.getAll();
    this.subscription = this.eventService.getAll().subscribe(res => {
      this.events = res;
      this.filteredEvents = this.events;
    });
  }

  filter(field: string, value: string) {
    this.filteredEvents = this.events.filter(i => i[field].toLowerCase().includes(value.toLowerCase()));
  }

  getImage(image: any) {
    return image != null ? image : this.PLACEHOLDER_IMAGE;
  }


  toggleEvent(id: string, value: boolean) {
    return this.eventService.toggleVisibility(id, value);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
